import React from "react";
import { formatApiDateTime } from "../../../tools/formatApiDateTime";
import { LABELISATION_TYPES } from "pages/project/components/utils";

interface Props {
  project: {
    name?: string;
    createdDate?: string;
    creationDate?: string;
    client?: { name?: string };
    labelingTypes?: Array<{ name?: string }>;
  };
}

const ImportProjectSummary = ({ project }: Props) => {
  const d = project.createdDate || project.creationDate;
  const items = [
    { label: "Projet", value: project.name },
    { label: "Client", value: project.client?.name },
    {
      label: "Type",
      value: LABELISATION_TYPES.find(
        (t) => t.id === project.labelingTypes?.[0]?.name,
      )?.text,
    },
    {
      label: "Créé le",
      value: d ? formatApiDateTime(d) : null,
    },
  ].filter((item) => item.value);

  if (!items.length) return null;

  return (
    <div
      style={{
        margin: "0",
        padding: "12px 16px",
        borderRadius: 4,
        border: "1px solid rgba(72,72,72,.12)",
        backgroundColor: "#f8f9fa",
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap",
        gap: 0,
      }}
    >
      {items.map((item, i) => (
        <div
          key={item.label}
          style={{ display: "flex", alignItems: "stretch" }}
        >
          {i > 0 && (
            <div
              style={{
                width: 1,
                backgroundColor: "rgba(72,72,72,.15)",
                margin: "0 20px",
                alignSelf: "stretch",
              }}
            />
          )}
          <div>
            <span
              style={{
                display: "block",
                fontSize: 11,
                fontWeight: 500,
                color: "#999",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
                marginBottom: 3,
              }}
            >
              {item.label}
            </span>
            <span
              style={{
                fontSize: 14,
                fontWeight: 500,
                color: "#333",
              }}
            >
              {item.value}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ImportProjectSummary;
